import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from '@/store';

/** Typed `useDispatch` — use this instead of the raw hook */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/** Typed `useSelector` — use this instead of the raw hook */
export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector<RootState, T>(selector);
